import React from 'react';
import { motion } from 'framer-motion';
import SectionShell from './Chapter';
import { SITE } from '@/constants/testIds';

const REASONS = [
  {
    n: '01',
    title: 'Senior-led, always',
    body:
      'Every mandate is handled directly by senior partners with decades of transaction experience. No juniors, no farmed-out execution.',
  },
  {
    n: '02',
    title: 'Founder-aligned',
    body:
      'We speak the language of founders, promoters and family owners — commercial, direct and mindful of the person whose name is on the door.',
  },
  {
    n: '03',
    title: 'Cross-border in practice',
    body:
      'Real deal execution across India, MENA and Hong Kong — with local relationships and international grammar, not just a map on a slide.',
  },
  {
    n: '04',
    title: 'Execution over theatre',
    body:
      'We build the deal to close. Materials, positioning and process exist to move a transaction forward — not to fill a data-room for the sake of it.',
  },
  {
    n: '05',
    title: 'Candor by default',
    body:
      'If a transaction is not the right transaction, we say so. Trust is built by the advice we decline to give as much as the advice we do.',
  },
  {
    n: '06',
    title: 'Discreet by design',
    body:
      'Client identities, financials and situations are held in strict confidence. Reputation compounds slowly — we protect it.',
  },
];

export const WhyNoBS = () => {
  const ease = [0.22, 1, 0.36, 1];
  return (
    <SectionShell
      id="why"
      testId={SITE.why}
      theme="light"
      index="03"
      eyebrow="Why NoBS"
      title={
        <>
          Six commitments we&apos;re prepared to be held to — from
          <span className="italic text-[color:var(--gold-3)]"> first call </span>
          to close.
        </>
      }
      intro="These are working principles, not marketing bullets. They govern how we scope, staff and see mandates through."
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-12 md:gap-y-16">
        {REASONS.map((r, i) => (
          <motion.div
            key={r.n}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-10% 0px' }}
            transition={{ duration: 0.7, delay: i * 0.06, ease }}
            className="border-t border-[color:var(--rule-light)] pt-6"
          >
            <div className="flex items-center justify-between small-caps text-[11px] text-[color:var(--charcoal-2)]">
              <span className="text-[color:var(--gold-3)]">{r.n}</span>
              <span>Principle</span>
            </div>
            <h3 className="mt-5 font-serif text-[24px] md:text-[28px] leading-[1.15] tracking-[-0.01em] text-[color:var(--charcoal)]">
              {r.title}
            </h3>
            <p className="mt-4 text-[15px] leading-[1.6] text-[color:var(--charcoal-2)] max-w-[440px]">
              {r.body}
            </p>
          </motion.div>
        ))}
      </div>
    </SectionShell>
  );
};

export default WhyNoBS;
